import { render } from "./ResearchFellowsComponent.vue?vue&type=template&id=3f8d4006&scoped=true"
import script from "./ResearchFellowsComponent.vue?vue&type=script&lang=js"
export * from "./ResearchFellowsComponent.vue?vue&type=script&lang=js"

import "./ResearchFellowsComponent.vue?vue&type=style&index=0&id=3f8d4006&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f8d4006"]])

export default __exports__